module.exports = __webpack_public_path__ + "assets/img/4_125_big.e02a9f6b.jpg";